import { Navigate, useParams } from 'react-router-dom';

import { CATALOGS } from '@/constants/permissions';
import { useMercuryPermissions } from '@/hooks/useMercuryPermissions';

/**
 * `/location/:entity` opens the country profile for callers who can use the
 * country catalog, and the location search for everyone else.
 */
const LocationAliasRedirect = () => {
  const { entity } = useParams();
  const { hasAccess } = useMercuryPermissions();
  const id = entity ?? '';

  if (hasAccess({ modules: CATALOGS.countries.modules })) {
    return <Navigate to={`/catalogs/countries/entity/${id}`} replace />;
  }

  return <Navigate to={`/search?q=locations.id:${id}`} replace />;
};

export default LocationAliasRedirect;
